module.exports = __webpack_public_path__ + "img/power.154d60f0.png";